import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import { reportApiError } from '../../../../utils/reportApiError';
import PromemoriaScadenzeDialog from './PromemoriaScadenzeDialog';

/**
 * The "Promemoria scadenze" button of the Documenti toolbar and the dialog it
 * opens. When the read on mount did not get the configuration, the button reads
 * it again and reports the failure: the dialog never opens on defaults it would
 * then save over the real configuration.
 */
const PromemoriaScadenzeButton = ({
  esercizioId,
  promemoria,
  onAvviso,
  className,
}) => {
  const [aperto, setAperto] = useState(false);
  const [lettura, setLettura] = useState(false);

  const apri = () => {
    if (promemoria.configurazione) {
      setAperto(true);
      return;
    }
    setLettura(true);
    promemoria
      .leggi()
      .then(() => {
        setLettura(false);
        setAperto(true);
      })
      .catch((errore) => {
        setLettura(false);
        reportApiError(errore);
      });
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<NotificationsNoneOutlinedIcon />}
        onClick={apri}
        disabled={lettura}
        className={className}
      >
        Promemoria scadenze
      </Button>
      {aperto && promemoria.configurazione && (
        <PromemoriaScadenzeDialog
          esercizioId={esercizioId}
          configurazione={promemoria.configurazione}
          onChiudi={() => setAperto(false)}
          onSalvata={(salvata) => {
            promemoria.aggiorna(salvata);
            setAperto(false);
            onAvviso('Impostazioni promemoria salvate', 'success');
          }}
          onAvviso={onAvviso}
        />
      )}
    </>
  );
};

PromemoriaScadenzeButton.propTypes = {
  esercizioId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  promemoria: PropTypes.shape({
    configurazione: PropTypes.object,
    leggi: PropTypes.func.isRequired,
    aggiorna: PropTypes.func.isRequired,
  }).isRequired,
  onAvviso: PropTypes.func.isRequired,
  className: PropTypes.string,
};

PromemoriaScadenzeButton.defaultProps = {
  className: undefined,
};

export default PromemoriaScadenzeButton;
